
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import Footer from "../../components/molecules/footer/Footer";
import Header from "../../components/molecules/header/Header";
import { loginSSO } from "../../components/services/LoginService";
import useSSO from "../../hooks/useSSO";
import ErrorMessage from "../../components/atoms/mensajesError/ErrorMessage";

const LoginClave = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [sso] = useSSO();
  const mensajeError = location.state?.errorMessage;

  const [values] = useState({
    username: "",
    password: "",
  });

  const [error, setError] = useState("");
  const [loginCorrecto, setLoginCorrecto] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loginCredencialesBloqueado,] = useState(null)
  // const {credActivo,setCredActivo} = useAuthentication()
  const handleShowPasswordClick = () => {
    setShowPassword(!showPassword);
  };

  
  
  
  useEffect(() => {
    localStorage.clear();
    localStorage.setItem("credbloqueado",JSON.stringify(loginCredencialesBloqueado))
    if (sso && sso !== "No tiene") {
      
      loginSSO(sso)
        .then((data) => {
          localStorage.setItem("token", sso);
          if (data === "NO AUTORIZADO") {
            setError("Error en las credenciales");
            localStorage.removeItem("token");
          } else {
            navigate("/home");
          }
        })
        .catch(() => {
          setError("Error en la conexión con SSO");
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sso,loginCredencialesBloqueado]);


  

   useEffect(() => {
      // getEstadoAccesoCredenciales().then((data) => {
      //   // true → hay acceso (permitido), false → no hay acceso
      //   setLoginCredencialesBloqueado(!data);// invertimos porque en el original era "bloqueado"
      //   setCredActivo(data) 
      // }).catch((err) => {
      //   // console.error("Error obteniendo estado de acceso:", err);
      //   // Por precaución, bloqueamos si hay error
      //   setLoginCredencialesBloqueado(true);
      // });
      
    }, []);
    
    
    localStorage.setItem("credbloqueado",JSON.stringify(loginCredencialesBloqueado))
   
    

  return (
    <>
      {/* Si se añaden distintos dominios se podria obtener a través para idnicar donde se desea mostrar y donde no con : 
      window.location.hostname; */}
      {loginPersonal(
        values,
        setLoginCorrecto,
        setError,
        navigate,
        error,
        mensajeError,
        loginCorrecto,
        showPassword,
        handleShowPasswordClick
      )}

      {/*process.env.REACT_APP_DOMINIO === window.location.hostname
        ? cargaPagina(error)
        : loginPersonal(
            values,
            setLoginCorrecto,
            setError,
            navigate,
            error,
            loginCorrecto,
            showPassword,
            handleShowPasswordClick
          )*/}
    </>
  );
};
export default LoginClave;
/*
function cargaPagina(error) {
  return (
    <div className="sso-loading">
      {!error ? "ESTOY CARGANDO LA PAGINA SSO" : error}
    </div>
  );
}*/

function loginPersonal(
  values,
  setLoginCorrecto,
  setError,
  navigate,
  error,
  mensajeError,
  loginCorrecto,
  showPassword,
  handleShowPasswordClick
) {
  return (
    <div className="me-auto ms-auto d-flex flex-column vh-100">
      <Header login={true}></Header>
      <main className="my-auto">
        <div className="row text-center login-page" role="main" data-landmark-index="4">
          <div className="d-flex flex-column ">
 
          {mensajeError ?  <ErrorMessage errorMessage={mensajeError} tiempo={3000} /> : null}

            <div className="col-md-12 card card-login">
              <div className="row">
                <div className="col-md-12 login-form-header">
                  <h2 className="login-form-font-header">
                    <span>ACCESO POR CL@VE</span>
                  </h2>
                </div>
              </div>
              <div className="row d-flex col-12 flex-nowrap justify-content-center mx-auto">
                <div className="col-12 card">
                  Acceder con:
                  <Link to={process.env.REACT_APP_API_URL + "/clave"} role="button" tabIndex={1}>
                    <button type="submit" className="btn" tabIndex={0}>
                      CL@VE
                    </button>
                  </Link>
                </div>

              </div>


            </div>

          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  );
}
